import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Empty } from '@easymoving/ui';
import { useItems } from '../../hooks/useUserData';
import { filterNeedsDecision } from '../../lib/query/needs';
import { ItemCard } from '../../components/items/ItemCard';
import { AddItemTile } from '../../components/items/AddItemTile';

/** Items still waiting on a decision / missing room or category (PRD §10.5). */
export function NeedsDecisionPage() {
  const { t } = useTranslation();
  const { items, loading } = useItems();
  const pending = useMemo(() => filterNeedsDecision(items), [items]);

  if (loading) {
    return (
      <Container className="pt-6">
        <p className="text-graphite py-12">{t('common.loading')}</p>
      </Container>
    );
  }

  if (pending.length === 0) {
    return (
      <Container className="pt-10">
        <Empty title={t('needs.empty')} body={t('needs.emptyBody')} />
      </Container>
    );
  }

  return (
    <Container className="pt-6">
      <div className="flex items-center justify-between mb-4">
        <h1 className="font-display text-2xl tracking-snug">{t('needs.title')}</h1>
        <span className="text-graphite-soft text-[14px] tnum">
          {t('gallery.resultCount', { count: pending.length })}
        </span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3" data-testid="item-grid">
        {pending.map((item) => (
          <ItemCard key={item.id} item={item} />
        ))}
        <AddItemTile />
      </div>
    </Container>
  );
}
